<template>
  <div>
    <div>
      <div>
        <v-text-field
            outlined
            dense
            label="From"
            hide-details="auto"
            type="text"
            class="mb-3"
            :value="selectedNode.settings.from"
            @input="(val) => onUpdate(val, 'settings.from')"
        ></v-text-field>
      </div>
      <v-select
          class="mb-3 mt-2"
          outlined
          dense
          :value="selectedNode.settings.to"
          @input="(val) => onUpdate(val, 'settings.to')"
          item-text="name"
          item-value="name"
          :items="availableInputFields"
          label="File Base64"
          clearable></v-select>
      <div>
        <v-text-field
            outlined
            dense
            label="Subject"
            hide-details="auto"
            type="text"
            class="mb-3"
            :value="selectedNode.settings.subject"
            @input="(val) => onUpdate(val, 'settings.subject')"
        ></v-text-field>
      </div>
      <mustache-template
          label="Body"
          :value="settings.body"
          @input="(val) => onUpdate(val, 'settings.body')"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from "lodash/cloneDeep";
import MustacheTemplate from "@/components/mustache/mustache-template.vue";

const { mapGetters: workflowDetailsGetters } =
    createNamespacedHelpers('workflows/details');

export default {
  name: 'aws-ses-send-email',
  props: {
    availableInputFields: { required: true },
  },
  components: {MustacheTemplate},
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    settings() {
      return this.selectedNode.settings;
    },
    showAddMetadataBtn() {
      const metadata = this.settings.metadata;
      return (
          !metadata ||
          !metadata[0] ||
          (metadata[metadata.length - 1].name && metadata[metadata.length - 1].value)
      );
    },
  },
  methods: {
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    addMetadata() {
      let settings = cloneDeep(this.settings);
      if (!settings.metadata) {
        settings.metadata = [];
      }

      settings.metadata.push({
        name: '',
        value: '',
      });
      this.onUpdate(settings, 'settings');
    },
    deleteMetadata(index) {
      const settings = cloneDeep(this.settings);
      settings.metadata.splice(index, 1);
      if (!settings.metadata.length) delete settings.metadata;

      this.onUpdate(settings, 'settings');
    },
  },
};
</script>

<style scoped lang="scss">
@import './aws-claude';
</style>
